<template>
  <div>
    <div class="text-center">
      <b-card-text class="mt-2 h4 color-inherit text-reset">
        {{ $t('home_new_document_title_1') }}
      </b-card-text>
    </div>
    <b-list-group class="mt-3 rounded-0">
      <b-list-group-item class="bg-transparent">
        <!-- ToDo -->
      </b-list-group-item>
      <b-list-group-item class="bg-transparent right-align">
        <b-button v-ripple.400="'rgba(255, 255, 255, 0.15)'" type="submit" variant="primary" class="mr-1" :disabled="name.length === 0">
          {{ $t('btn_create') }}
        </b-button>
      </b-list-group-item>
    </b-list-group>
  </div>
</template>

<script>
import { BButton, BListGroup, BListGroupItem, BCardText } from 'bootstrap-vue'
import Ripple from 'vue-ripple-directive'

export default {
  components: {
    BButton,
    BListGroup,
    BListGroupItem,
    BCardText
  },
  directives: {
    Ripple
  },
  data() {
    return {
      name: ''
    }
  },
  methods: {
    onClickCreate() {
      this.$store.dispatch('homeAddNew/createDocument', { self: this, name: this.name })
    }
  }
}
</script>
<style lang="scss" scoped>
.list-group-item {
  border: none !important;
}
</style>
